import { useRef, useState } from 'react'
import { Link } from 'react-router'
import { useAddClientMutation, useGetClientsQuery } from 'src/redux/Api/clientsApi'
import Loader from 'src/Components/Loader'
import Popup from 'src/Components/Popup'
import Input from 'src/Components/Form/Input'
import { IClientCreate } from 'src/utils/Interfaces/client.interface'
import TextArea from 'src/Components/Form/TextArea'
import MediaInput from 'src/Components/Form/MediaInput'
import style from './style.module.scss'

const Clients = () => {
  const [newClientPopup, setNewClientPopup] = useState(false)
  const [newClient, setNewClient] = useState({} as IClientCreate)
  const [addNewClient] = useAddClientMutation()
  const { data, isLoading } = useGetClientsQuery()
  const mediaRef = useRef<HTMLInputElement>(null)

  const handleNewClient = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const imgs = mediaRef.current?.files
    if (imgs) {
      const formData = new FormData()
      formData.append('file', imgs[0])
      formData.append('name', newClient.name)
      formData.append('siteUrl', newClient.siteUrl)
      formData.append('type', newClient.type)
      formData.append('baseInfo', newClient.baseInfo)
      await addNewClient(formData)
    }
  }

  return (
    <>
      <h1>Clients</h1>
      <section className="block">
        <div className="control">
          <button className="btn" onClick={() => setNewClientPopup(true)}>
            Add new client
          </button>
        </div>
        <ul className={style.clients_list}>
          <li className={style.titles}>
            <span>Name</span>
            <span>Site URL</span>
            <span>Type</span>
            <span>Status</span>
            <span></span>
          </li>
          {isLoading ? (
            <Loader height={30} />
          ) : (
            data?.map((item) => (
              <li key={item.id}>
                <span className={style.name}>
                  <div className={style.img}>
                    <img src={item.logo} alt="logo" />
                  </div>
                  <Link to={`/clients/${item.id}`}>
                    {item.name}
                  </Link>
                </span>
                <span>
                  <a href={item.siteUrl} target="_blank">
                    {item.siteUrl}
                  </a>
                </span>
                <span>{item.type}</span>
                <span>{item.status}</span>
                <span>
                  <img src="/src/assets/img/icons/dots.svg" alt="dots" />
                </span>
              </li>
            ))
          )}
        </ul>

        {newClientPopup && (
          <Popup closePopup={() => setNewClientPopup(false)} title="New client" className={style.new_client}>
            <form onSubmit={handleNewClient}>
              <Input
                label="Name"
                name="name"
                value={newClient.name}
                onChange={(e) => setNewClient({ ...newClient, name: e.target.value })}
              />
              <Input
                label="Site URL"
                name="site"
                value={newClient.siteUrl}
                onChange={(e) => setNewClient({ ...newClient, siteUrl: e.target.value })}
              />
              <MediaInput ref={mediaRef} />
              <Input
                label="Type"
                name="type"
                value={newClient.type}
                onChange={(e) => setNewClient({ ...newClient, type: e.target.value })}
              />
              <TextArea
                label="Base Info"
                name="base_info"
                value={newClient.baseInfo}
                onChange={(e) => setNewClient({ ...newClient, baseInfo: e.target.value })}
              />
              <button className="btn">Add</button>
            </form>
          </Popup>
        )}
      </section>
    </>
  )
}

export default Clients
